export enum ConfirmationState {
  Termination,
  Logout,
  Delete,
}
